<template>
    <div class="list">
        <div class="box-header" :class="{active: isActive}" @click="$emit('toggle')">
            {{ label }}
        </div>
        <div class="box-detail" :class="{boxblock: isActive}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        isActive: {
            type: Boolean,
            default: false
        }
    },
    emits: ['toggle'],

}
</script>

<style scoped lang="scss">
.list {
    margin: 5px;
    width: 270px;
    height: 60px;
    position: relative;

    .box-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 45px;
        font-size: 1rem;
        color: #000;
        cursor: pointer;
        border-radius: 29px;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        width: 100%;
        padding: 10px 20px;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            right: 20px;
            top: 0;
            bottom: 0;
            margin: auto;
            border: 1px solid #ff8c00;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
            transition: all 0.4s ease 0s;
        }

        &.active {
            border-radius: 29px 29px 0 0;
            box-shadow: unset;

            &::after {
                transform: rotate(-135deg);
            }
        }
    }

    .box-detail {
        position: absolute;
        width: 100%;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        border-radius: 0 0 29px 29px;
        padding: 20px;
        display: none;
        z-index: 11;

        &.boxblock {
            display: block;
        }

        // Styles pour les checklists
        :deep(.checklist) {
            height: 180px;
            overflow-y: auto;

            .check-box-custom {
               margin: 0px !important;
            }
        }

        // Styles pour les inputs min/max
        :deep(.box) {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-size: 1rem;
            color: #000;
            width: 100%;
            margin-bottom: 15px;

            .label-input {
                width: 40px;
            }

            .filter-input {
                border: none;
                border-bottom: 1px solid #ff8900;
                padding: 2px 0px;
                flex-grow: 3;
                margin-left: 20px;
            }

            input[type=number]::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }
        }

        // Styles pour les checkboxes
        :deep(.check-box-custom) {
            display: flex !important;
            align-items: center;
            gap: 10px;
            border-radius: 4px;
            transition: background 0.2s ease;

            &:hover {
                background: #f5f5f5;
            }

            input[type="checkbox"] {
                width: 18px;
                height: 18px;
                cursor: pointer;
                accent-color: #ff8c00;
                flex-shrink: 0;
            }

            .data, label.data {
                display: block !important;
                font-weight: normal;
                color: #333 !important;
                font-size: 14px;
                visibility: visible !important;
                opacity: 1 !important;
                cursor: pointer;
            }
        }
    }
}
</style>
